import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { getUserProfile, getExpireDate } from "helpers";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const getTypeNote = (url) => {
    let regex;
    // lilanews
    /* regex = /_0_([0-9a-zA-Z]|-|_)+\.html$/
    if (regex.test(url)) {
        return "lilanews";
    } */
    // recipe
    regex = /_7_([0-9a-zA-Z]|-|_)+\.html$/
    if (regex.test(url)) {
        return "recipe";
    }
    // video
    /* regex = /_3_([0-9a-zA-Z]|-|_)+\.html$/
    if (regex.test(url)) {
        return "video";
    } */
    // gallery
    /* regex = /_5_([0-9a-zA-Z]|-|_)+\.html$/
    if (regex.test(url)) {
        return "gallery";
    } */
    // not supported
    return "";
}

export const useCollectionsNews = (noteDetail, handleCollections, savedNoteStatus, setSavedNoteStatus) => {

    const dataContext = useContext(TemplateContext);
    const { 
        recipes = [],
        setRecipes = false,
        collectionList = [],
        setCollectionList = false,
        setIsLoading = false,
        setSavedRecipesCount = () => {}
    } = dataContext?.content ?? {};

    const type = getTypeNote(noteDetail?.url);

    const { loginWithRedirect } = useAuth0();

    const btnSaveNews = useRef();
    const formSaveNews = useRef();

    const itemsPerPage = 5;
    const disabledTypeNews = type === "";

    const [openFormDel, setOpenFormDel] = useState(false);

    const [openForm, setOpenForm] = useState(false);

    const [openFormCollection, setOpenFormCollection] = useState(false);

    const [formStateCollection, setFormStateCollection] = useState({ collectionName: "" });

    const [openModalSuccessMessage, setOpenModalSuccessMessage] = useState(false);

    const [noteSaved, setNoteSaved] = useState({
        status: false,
        userId: null,
        noteActive: {
            cmd: "add",
            type: type,
            collectionName: "default",
            detail: {
                _id: noteDetail?._id,
                url: noteDetail?.url,
            }
        }
    });
    const [collectionsDisplay, setCollectionsDisplay] = useState([]);
    const [currentPageCollection, setCurrentPageCollection] = useState(1);
    const [totalPagesCollection, setTotalPagesCollection] = useState(1);

    const handleCollectionsDisplay = (page) => {
        if (page > totalPagesCollection) {
            return;
        }
        if (page < 1) {
            return;
        }        
        const start = (page - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        const collections = Object.keys(handleCollections?.collectionsUserRef?.current?.[type] ?? {});
        setCollectionsDisplay(collections?.slice(start, end));
        setCurrentPageCollection(page);
    }

    const getSavedUserNotes = async () => {
        try {
            if (handleCollections?.collectionsUserRef?.current) {
                const collections = Object.keys(handleCollections?.collectionsUserRef?.current?.[type] ?? {});
                collections?.forEach((collection) => {
                    const items = handleCollections?.collectionsUserRef?.current?.[type]?.[collection];
                    const find = items?.find((item) => item._id === noteDetail?._id);
                    if (find) {
                        setNoteSaved(state => ({
                            ...state,
                            noteActive: {
                                ...state.noteActive,
                                cmd: "remove",
                                collectionName: collection
                            }
                        }));
                        return;
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
      const collections = Object.keys(
        handleCollections?.collectionsUserRef?.current?.[type] ?? {}
      );
      if (validateUser() && collections.length > 0) {
        getSavedUserNotes();
        handleCollectionsDisplay(1);
        setTotalPagesCollection(Math.ceil(collections.length / itemsPerPage));
      }
    }, [handleCollections?.collectionsUserRef?.current, noteSaved?.userId, noteSaved?.status, savedNoteStatus]);

    useEffect(() => {
      const { id, subscriptionStatus } = getUserProfile() ?? {
        id: null,
        subscriptionStatus: null,
      };
      if (noteSaved?.userId !== id) {
        setNoteSaved((state) => ({
          ...state,
          userId: id,
          status: subscriptionStatus === "subscribed",
        }));
      }
    }, []);

    const saveNews = async (collectionName, collections ) => {
        try {
            if (!validateUser()) throw new Error("noteSaved.status");
            btnSaveNews.current.disabled = true;
            const newNoteTosave = { ...noteSaved };
            if (!!collectionName) {
                newNoteTosave.noteActive.collectionName = collectionName;
            }
            await axios({
                url: `/api/user-data/${encodeURIComponent(noteSaved.userId)}`,
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                //timeout: 8000,
                responseType: 'json',
                data: {
                    note: newNoteTosave.noteActive
                }
            });
            setNoteSaved(state => ({
                ...state,
                noteActive: {                    
                    ...newNoteTosave.noteActive,
                    cmd: newNoteTosave.noteActive.cmd === "add" ? "remove" : "add"
                }
            })); 
            if(btnSaveNews.current) {          
                btnSaveNews.current.disabled = false;
                btnSaveNews.current.style.display = 'block';
            }
            if(collections?.[type]?.[collectionName]) {
                collections[type][collectionName].push({
                    _id: noteDetail?._id,
                    url: noteDetail?.url,
                })
                handleCollections.collectionsUserRef.current = collections;
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    const onInputChangeCollection = ({ target }) => {
        const { name, value } = target;
        setFormStateCollection({
            [name]: value
        });
    }

    const onInputResetCollection = () => {
        setFormStateCollection({ collectionName: "" });
    }

    const onFormSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const { collectionName } = Object.fromEntries(formData.entries());
        if (!!collectionName && collectionName.length > 0) {
            const result = await saveNews(collectionName);
            if (result) {
                setOpenModalSuccessMessage(true);
                setOpenForm(false);
                event.target.reset();
                return;
            }
        }
        // error ?????????????????
        console.error('onFormSubmit');
    };

    const onFormSubmitCollection = async (event) => {
        event.preventDefault();
        const { collectionName } = formStateCollection;
        if (collectionName.length > 0) {
            const result = await handleCollections.addCollection(collectionName, noteSaved, type);
            if (result) {
                setOpenFormCollection(false);
                onInputResetCollection();
                //setOpenForm(true);
                //return;
                const resultSaveNews = await saveNews(collectionName,result);
                setSavedNoteStatus(state => state + 1)
                if (resultSaveNews) {
                    setOpenModalSuccessMessage(true);
                    formSaveNews?.current?.reset();
                    return;
                }
            }
        }
        // error ?????????????????
        console.error('onFormSubmitCollection');
    };

    const onBtnAddNews = () => {
        setOpenForm(false);
        setOpenFormCollection(true);
    };

    const onBtnAddNewsCancel = () => {
        btnSaveNews.current.style.display = 'block';
        setOpenForm(false);
    };

    const onBtnAddCollectionCancel = () => {
        setOpenFormCollection(false);
        setOpenForm(true);
        onInputResetCollection();
    };

    const onBtnDel = () => {
        console.log({noteSaved});        
        const result = saveNews();
        if (result) {
            setOpenFormDel(false);
            if(!!setRecipes && !!setCollectionList){
                const newCollectionList = [...collectionList];                
                const colection = newCollectionList.filter((item,index) => !!index).find( collection => {
                    const ids = collection.ids.split(',');
                    return ids.includes(noteSaved.noteActive.detail._id);
                });
                if (colection) {                     
                    setCollectionList(newCollectionList.map((item) => {
                        if (item.name === "Todas") {
                            item.count = item.count - 1;
                            item.ids = item.ids.replace(noteSaved.noteActive.detail._id, '');
                            item.ids = item.ids.replace(/,,/g, ',');
                            item.ids = item.ids.replace(/,$/, '');
                        }
                        if (item.name === colection.name) {
                            item.count = item.count - 1;
                            item.ids = item.ids.replace(noteSaved.noteActive.detail._id, '');
                            item.ids = item.ids.replace(/,,/g, ',');
                            item.ids = item.ids.replace(/,$/, '');
                        }
                        return item;
                    }));                   
                    const newsRecipes = [...recipes];
                    setRecipes(newsRecipes.filter((item) => item._id !== noteSaved.noteActive.detail._id));
                    setSavedRecipesCount((current) => current - 1);
                    setIsLoading(true);
                }                
            }            
        }
    };

    const onBtnDelCancel = () => {
        setOpenFormDel(false);
        btnSaveNews.current.style.display = 'block';
    };

    const redirectLogin = async () => {
        handleClick("ui_interaction", "header principal", "Boton Ingresar");
        let expDate = getExpireDate(1);
        document.cookie = `auth0_redir=${window.location.href
            };expires=${expDate.toUTCString()};path=/`;
        loginWithRedirect();
    };

    const validateUser = () => {
        if (!noteSaved.userId) {            
            return false;
        }
        /* if (!noteSaved.status) {            
            return false;
        } */
        return true;
    }

    const onBtnProcess = (event) => {
        if (!validateUser()) {
            redirectLogin();
            return;
        }
        const isAdding = noteSaved.noteActive.cmd === "add";
        if (isAdding) {
            setOpenForm(true);
        } else {
            setOpenFormDel(true);
        }
        handleClick("ui_interaction", "notas", `${isAdding ? "guardar" : "eliminar"} nota`
        );
    };

    const setDisplay = (cmd) => {
        return (noteSaved.noteActive.cmd == cmd) ? '' : 'none';
    }

    const setClassBtnProcess = () => {
        return (noteSaved.status)
            ? noteSaved.noteActive.cmd === "add" ? "btn-addNews" : "btn-delNews"
            : "btn-addNews-disabled";
    }

    const onBtnCloseModalSuccess = () => {
        setOpenModalSuccessMessage(false)
    }

    return {
        btnSaveNews,
        formSaveNews,
        collectionsDisplay,
        currentPageCollection,
        totalPagesCollection,
        handleCollectionsDisplay,
        disabledTypeNews,
        formStateCollection,
        noteSaved,
        onBtnCloseModalSuccess,
        onFormSubmit,
        onFormSubmitCollection,
        onInputChangeCollection,
        openForm,
        openFormCollection,
        openFormDel,
        openModalSuccessMessage,
        onBtnAddNews,
        onBtnAddNewsCancel,
        onBtnAddCollectionCancel,
        onBtnDel,
        onBtnDelCancel,
        onBtnProcess,
        setDisplay,
        setClassBtnProcess,
    }
};